import React from 'react';
import {
  FormControl,
  FormHelperText,
  Box,
  Chip,
} from '@mui/material';

import IOSSegmentedControl from '../common/IOSSegmentedControl';

import classes from './RenrolmentAccordian.module.css';
import Paragraph from '../Paragraph/Paragraph';
import StudentPhoto from '../StudentPhoto/StudentPhoto';
import { getChildCampusName, getStudentFullName } from '../../utils/parentHistoryHelpers';
import { reenrolmentYear } from '../../utils/years';

const RenrolmentAccordian = ({ showHCCfields, enrolledchildrens, formik, childRefs }) => {
  const nextYear = reenrolmentYear();

  return (
    <div className="renrolmentaccordian">
      {enrolledchildrens.map((child, index) => {
        const fieldName = `hccSelections[${index}]`;
        const fieldError = formik.errors.hccSelections?.[index];
        const fieldTouched = formik.touched.hccSelections?.[index];
        const value = formik.values.hccSelections?.[index];

        return (
          <div key={index} className={classes.databox} ref={childRefs[index]}>
            <div className={classes.datainnerbox}>
              <table className={classes.FeeTblinr}>
                <tbody className={classes.tbody}>
                  <tr>
                    <td>
                      {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        {false ?
                          <img
                            style={{
                              aspectRatio: 1 / 1,
                              width: '100px',
                              height: 'auto',
                              objectFit: 'cover',
                              borderRadius: '50%',
                              border: '4px solid #ffffff',
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                              transition: 'transform 0.3s ease',
                            }}
                            src={imgSrc}
                          /> :
                          <Avatar
                            sx={{
                              width: '100px',
                              height: '100px',
                              objectFit: 'cover',
                              bgcolor: '#246c34',
                              fontSize: '2rem',
                              fontWeight: 'bold',
                            }}
                          >
                            {getInitials(getStudentFullName(child))}
                          </Avatar>
                        }
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                          <Paragraph
                            fontWeight="600"
                            margin={0}
                            text={`${child.stud_code} - ${getStudentFullName(child)}`}
                          />
                          <Paragraph
                            text={`${nextYear} Year Level: ${child.year_grp === -1
                              ? 'KG'
                              : child.year_grp === 0
                                ? 'PP'
                                : `Y${child.year_grp}`
                              }`}
                          />
                        </Box>
                      </Box> */}

                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px' }}>

                        <Box className={classes.studentImageSection}>
                          <StudentPhoto
                            src={child.imageUrl}
                            name={getStudentFullName(child)}
                            imageClassName={classes.studentImage}
                            avatarClassName={classes.studentAvatar}
                          />
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                          <Paragraph
                            fontWeight="600"
                            margin={0}
                            text={`${child.stud_code} - ${getStudentFullName(child)}`}
                          />
                          {getChildCampusName(child) && (
                            <Chip
                              label={getChildCampusName(child)}
                              size="small"
                              sx={{
                                height: '22px',
                                fontSize: '12px',
                                fontWeight: 600,
                                mt: '4px',
                                mb: '4px',
                                color: '#1b5e20',
                                backgroundColor: 'rgba(27, 94, 32, 0.12)',
                                border: '1px solid rgba(27, 94, 32, 0.28)',
                              }}
                            />
                          )}
                          <Paragraph
                            text={`${nextYear} Year Level: ${child.year_grp === -1
                              ? 'KG'
                              : child.year_grp === 0
                                ? 'PP'
                                : `Y${child.year_grp}`
                              }`}
                          />
                        </Box>
                      </Box>
                    </td>
                    <td>

                    </td>
                  </tr>

                  {child.year_grp > 12 ? (
                    <tr>
                      <td>
                        <Paragraph text="Not Eligible for Re-enrolment" />
                      </td>
                    </tr>
                  ) : (
                    showHCCfields && (
                      <tr>
                        <td>
                          <FormControl
                            error={Boolean(fieldTouched && fieldError)}
                            size="small"
                            sx={{ width: '220px' }}
                          >
                            {/* A yes/no toggle, the same control the medical questions use.
                                This was the only dropdown left on the parent side, and a
                                dropdown for two options hides one of them until it is opened. */}
                            <IOSSegmentedControl
                              options={[{ label: 'YES', value: 'yes' }, { label: 'NO', value: 'no' }]}
                              value={value === 'please_select' ? null : value}
                              onChange={(picked) => {
                                formik.setFieldTouched(fieldName, true);
                                formik.setFieldValue(fieldName, picked);
                                formik.setFieldError(fieldName, undefined);
                              }}
                              error={Boolean(fieldTouched && fieldError)}
                              aria-label={`Health Care Card for ${getStudentFullName(child)}`}
                            />

                            {fieldTouched && fieldError && (
                              <FormHelperText sx={{ fontSize: '14px' }}>
                                {fieldError ||
                                  `Please select Yes or No for ${getStudentFullName(child)}`}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RenrolmentAccordian;
